import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceAppointment as Appointment } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map } from 'rxjs/operators';
import {
  AppointmentsEntityActionTypes,
  CreateAppointmentOnServer,
  CreateAppointmentOnServerSuccess,
  GetAppointmentsFromServer,
  GetAppointmentsFromServerSuccess,
  UpdateAppointmentOnServer,
  UpdateAppointmentOnServerError,
  UpdateAppointmentOnServerSuccess,
  DeleteAppointmentFromServer,
  DeleteAppointmentFromServerSuccess
} from './appointments.actions';

@Injectable()
export class AppointmentsEntityEffects {
  
  getSelectedAppointmentsFromServer = createEffect(() => this.dataPersistence.fetch(
    AppointmentsEntityActionTypes.GetAppointmentsFromServer,
    {
      run: (action: GetAppointmentsFromServer, state: any) => {
        return this.apiService
          .get<Appointment[]>(`v/2/fixed-operations/appointments`, {
            params: action.payload.params
          })
          .pipe(
            map(Appointments => {
              return new GetAppointmentsFromServerSuccess(Appointments);
            })
          );
      },
      onError: (action: GetAppointmentsFromServer, error) => {
        console.error('Error', error);
      }
    }
  ));

  
  updateAppointmentOnServer = createEffect(() => this.dataPersistence.fetch(AppointmentsEntityActionTypes.UpdateAppointmentOnServer, {
    run: (action: UpdateAppointmentOnServer, state: any) => {
      return this.apiService
        .put<Appointment[]>(
          `v/2/fixed-operations/appointments/${action.payload.appointment.id}`,
          action.payload.appointment,
          {
            params: action.payload.appointmentQueryParams
          }
        )
        .pipe(
          map(Appointment => {
            return new UpdateAppointmentOnServerSuccess(Appointment);
          })
        );
    },
    onError: (action: UpdateAppointmentOnServer, error: unknown) => {
      console.error('Error', error);
      return new UpdateAppointmentOnServerError({
        appointment: action.payload.appointment,
        error,
      });
    }
  }));

  
  createAppointmentOnServer = createEffect(() => this.dataPersistence.fetch(AppointmentsEntityActionTypes.CreateAppointmentOnServer, {
    run: (action: CreateAppointmentOnServer, state: any) => {
      return this.apiService
        .post<Appointment[]>(`v/2/fixed-operations/appointments`, action.payload.appointment, {
          params: action.payload.appointmentQueryParams
        })
        .pipe(
          map(Appointment => {
            return new CreateAppointmentOnServerSuccess(Appointment);
          })
        );
    },
    onError: (action: CreateAppointmentOnServer, error) => {
      console.error('Error', error);
    }
  }));

  
  deleteAppointmentFromServer = createEffect(() => this.dataPersistence.fetch(AppointmentsEntityActionTypes.DeleteAppointmentFromServer, {
    run: (action: DeleteAppointmentFromServer, state: any) => {
      return this.apiService
        .delete<Appointment[]>(
          `v/2/fixed-operations/appointments/${action.payload.appointment.id}`,
          action.payload.appointment
        )
        .pipe(
          map(appointment => {
            return new DeleteAppointmentFromServerSuccess({ appointment: action.payload.appointment });
          })
        );
    },
    onError: (action: DeleteAppointmentFromServer, error) => {
      console.error('Error', error);
    }
  }));

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<any>,
    private apiService: ApiService,
    private router: Router
  ) {}
}
